import { BookPromotion } from './BookPromotion'
import { withBookPromotion } from './withBookPromotion'

const ConnectedBookPromotion = withBookPromotion(BookPromotion)

export { ConnectedBookPromotion as BookPromotion }
